// CLOSED: closed for everybody
// PRE_LAUNCH: open for merchant only
// OPEN: open for everybody
export default {
  CLOSED: 'CLOSED',
  PRE_LAUNCH: 'PRE_LAUNCH',
  OPEN: 'OPEN',
}
